<div class="resetPassword">
  <div class="logo">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6">
          <div class="logo-main">
            <div class="ourlogo">
              <img src="/assets/images/Piqet_NewLogo.png" alt="Logo" />
            </div>
            <div class="rightside-text">
              <div class="logo1">
                Powering your <br />
                sustainability journey
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="submit()">
        <div class="content">
          <p>Reset password</p>
          <div class="form-group required">
            <div class="services-form">
              <input
                class="form-control feildBorder"
                formControlName="password"
                [type]="fieldTextTypeNewPwd ? 'text' : 'password'"
                placeholder="New password"
                (keyup)="validationsPassword()"
              />
              <label>New password</label>
              <div class="input-group-append">
                <span class="input-group-text">
                  <img
                    [src]="
                      fieldTextTypeNewPwd ? 'assets/images/Eye.png' : 'assets/images/EyeCross.png'
                    "
                    (click)="toggleFieldNewPwd()"
                  />
                </span>
              </div>

              <div class="security-tabs">
                <p [ngClass]="upperCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One uppercase character
                </p>
                <p [ngClass]="lowerCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One lowercase character
                </p>
                <p [ngClass]="numberCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One number
                </p>
                <p [ngClass]="specialCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                  One special character
                </p>
                <p [ngClass]="minLengthsflag ? 'hightlightText' : 'NonhightlightText'">
                  8 characters minimum
                </p>
              </div>
            </div>
          </div>
          <div class="form-group required">
            <div class="services-form">
              <input
                class="form-control feildBorder"
                [type]="fieldTextType ? 'text' : 'password'"
                formControlName="confirmPassword"
                type="password"
                placeholder="Confirm password"
              />
              <label>Confirm password</label>
              <div class="input-group-append">
                <span class="input-group-text">
                  <img
                    [src]="fieldTextType ? 'assets/images/Eye.png' : 'assets/images/EyeCross.png'"
                    (click)="toggleFieldOldPwd()"
                  />
                </span>
              </div>
              <div
                *ngIf="
                  resetPasswordForm.controls['confirmPassword'].touched &&
                  resetPasswordForm.controls['confirmPassword'].errors
                "
                class="input-error"
              >
                <div *ngIf="resetPasswordForm.controls['confirmPassword'].errors?.['required']">
                  The confirm password field is required.
                </div>
                <div *ngIf="resetPasswordForm.controls['confirmPassword'].errors?.['mustMatch']">
                  The password and confirm password fields do not match
                </div>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <div>
              <button
                type="submit"
                class="btn blue-hoki pull-right"
                [disabled]="!resetPasswordForm.valid"
              >
                Submit
              </button>
            </div>
          </div>
          <div class="text-center backLogin">
            <a class="linkText" routerLink="/login">Back to log in</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
